/**
 * scents
 * Complete data for all 15 Pauline's massage candle variants.
 * lid:  key matching sources.js entry name for GLTF lookup.
 * icon: path to PNG icon in static/textures/icons/
 * desc: full scent description shown on card click.
 */
export const SCENTS = [
    {
        id: 1, lid: 'lid-01',
        name: 'Coconut & Mandarin',
        category: 'essential',
        notes: ['coconut', 'mandarin'],
        desc: 'Citrus aroma of tangerine and coconut essential oils.',
    },
    {
        id: 2, lid: 'lid-02',
        name: 'Lavender & Vanilla',
        category: 'essential',
        notes: ['lavender', 'vanilla'],
        desc: 'All-balanced combination of fresh lavender and vanilla beans.',
    },
    {
        id: 3, lid: 'lid-03',
        name: 'Orange & Cinnamon',
        category: 'essential',
        notes: ['orange', 'cinnamon'],
        desc: 'A wonderful combination of citrus orange aroma with cinnamon essential oils.',
    },
    {
        id: 4, lid: 'lid-04',
        name: 'Lime & Lemongrass',
        category: 'essential',
        notes: ['lime', 'lemongrass'],
        desc: 'Aroma of juicy lime with a hint of morning lemon — herbaceous scent of lemongrass essential oils.',
    },
    {
        id: 5, lid: 'lid-05',
        name: 'Patchouli, Lemon & Bergamot',
        category: 'essential',
        notes: ['patchouli', 'lemon', 'bergamot'],
        desc: 'Woody aroma with citrus notes of lemon and herbal notes of bergamot essential oils.',
    },
    {
        id: 6, lid: 'lid-06',
        name: 'Ylang-Ylang & Lemon',
        category: 'essential',
        notes: ['ylang-ylang', 'lemon'],
        desc: 'Woody floral aroma of ylang-ylang combined with citrus notes of lemon essential oils.',
    },
    {
        id: 7, lid: 'lid-07',
        name: 'Forest Berries',
        category: 'aromatic',
        notes: ['forest berries'],
        desc: 'Delicate sweet taste of currants, berries, bergamot, amber and spices.',
    },
    {
        id: 8, lid: 'lid-08',
        name: 'Grapefruit & Bergamot',
        category: 'aromatic',
        notes: ['grapefruit', 'bergamot'],
        desc: 'Aroma of sweet citrus in a combination of grapefruit, bergamot and lemon.',
    },
    {
        id: 9, lid: 'lid-09',
        name: 'Buddha Wood',
        category: 'perfumed',
        notes: ['cedarwood', 'amber', 'musk'],
        desc: 'The aroma of nutmeg and top notes of mint are accompanied by cardamom, frankincense and sandalwood. A trail of musk and amber will leave a unique woody scent on your skin.',
    },
    {
        id: 10, lid: 'lid-10',
        name: 'Lila Black',
        category: 'perfumed',
        notes: ['lilac', 'violet', 'night musk'],
        desc: 'A unisex fragrance. Gentle violet and lilac are complemented by woody aromas of oud and cedar, a faint note of vanilla and tonka bean, and sandalwood, amber and patchouli complete this ensemble.',
    },
    {
        id: 11, lid: 'lid-11',
        name: 'Shea Butter',
        category: 'aromatic',
        notes: ['shea', 'vanilla cream'],
        desc: 'Milky sweet aroma of delicate shea nut.',
    },
    {
        id: 12, lid: 'lid-12',
        name: 'Flower Splash',
        category: 'aromatic',
        notes: ['floral bouquet'],
        desc: 'The seductive aroma of orange blossoms, musk and tea opens with notes of rose and leather and ends with a light trail of vetiver and sandalwood.',
    },
    {
        id: 13, lid: 'lid-13',
        name: 'Yoga Time',
        category: 'perfumed',
        notes: ['sandalwood', 'eucalyptus', 'herbs'],
        desc: 'After spicy opening notes of ginger and cardamom, this spa fragrance opens with amber, spice and nutmeg and ends with a trail of cedar, sandalwood, vanilla and musk.',
    },
    {
        id: 14, lid: 'lid-14',
        name: 'Lost Cherry',
        category: 'perfumed',
        notes: ['cherry', 'dark plum', 'tonka'],
        desc: 'The aroma of ripe cherries, seasoned with sweet Griotte syrup and a faint hint of bitter almonds. The heart of the fragrance explodes with waves of Turkish rose and jasmine. The trail — sweet nutty Tonka beans, sandalwood, vetiver and cedar — will remain on your skin for a long time.',
    },
    {
        id: 15, lid: 'lid-15',
        name: 'Tobacco & Vanille',
        category: 'perfumed',
        notes: ['tobacco', 'vanilla', 'amber'],
        desc: 'Bright, warm and iconic. Reminiscent of an English gentlemen\'s club. Blended with rich spices, vanilla and tobacco flower. It leaves a powerful impression.',
    },
]
